import { ClientWebPageProps } from '@common/model/meta/clientWebPageProps';
import { useClientWebRouteParams } from './useClientWebRouteParams';

/**
 * Returns current route page props
 */
export const useClientWebRouteProps = <P extends keyof ClientWebPageProps>() => {
  return useClientWebRouteParams().pageProps as ClientWebPageProps[P];
};
